document.addEventListener('DOMContentLoaded', () => {
	const body = document.body;
	const toggleButton = document.querySelectorAll('.offcanvas-toggler');
	const offCanvasAll = document.querySelectorAll('.offcanvas');

	toggleButton.forEach((button) => {
		const offCanvas = document.querySelector('[data-toggler="' + button.dataset.toggle + '"]');

		offCanvas.classList.remove('!hidden');

		button.addEventListener('click', () => {
			const willOpen = !offCanvas.hasAttribute('data-open');
			toggleOffCanvas(offCanvas, toggleButton);
			body.classList.toggle('offcanvas-open');
			if (offCanvas.dataset.overlay) {
				body.classList.toggle('offcanvas-overlay');
			}
			toggleOffCanvasTabbing();

			if (willOpen) {
				const focusTarget = offCanvas.querySelector(
					'button:not([tabindex="-1"]), a:not([tabindex="-1"]), input:not([tabindex="-1"]), [tabindex="0"]'
				);
				if (focusTarget) {
					focusTarget.focus();
				}
			} else if (button.classList.contains('offcanvas-toggler')) {
				const openTrigger = document.querySelector(
					'.offcanvas-toggler.filters-trigger[aria-controls="' +
						offCanvas.id +
						'"], .offcanvas-toggler.mobile-nav-btn[aria-controls="' +
						offCanvas.id +
						'"], .offcanvas-toggler[aria-controls="' +
						offCanvas.id +
						'"]'
				);
				if (openTrigger) {
					openTrigger.focus();
				}
			}
		});
	});

	offCanvasAll.forEach((offCanvas) => {
		const subMenuParent = offCanvas.querySelectorAll('.menu-item-has-children');
		const dropdownIcons = offCanvas.querySelectorAll('.fa-chevron-down');

		dropdownIcons.forEach((icon) => icon.setAttribute('tabindex', '-1'));

		subMenuParent.forEach((parent) => {
			if (!parent.querySelector('.fa-chevron-down')) {
				return;
			}
			parent.querySelector('.fa-chevron-down').addEventListener('click', (e) => {
				e.preventDefault();
				toggleMobileSubmenu(parent);
			});
			parent.querySelector('.fa-chevron-down').addEventListener('keyup', (e) => {
				if ('Enter' === e.key) {
					e.preventDefault();
					toggleMobileSubmenu(parent);
				}
			});
		});

		// Close offcanvas on Esc
		document.addEventListener('keyup', (e) => {
			if (
				'Escape' === e.key &&
				body.classList.contains('offcanvas-open') &&
				offCanvas.hasAttribute('data-open')
			) {
				toggleOffCanvas(offCanvas, toggleButton);
				body.classList.remove('offcanvas-open');
				toggleOffCanvasTabbing();

				const openTrigger = document.querySelector(
					'.offcanvas-toggler.filters-trigger[aria-controls="' +
						offCanvas.id +
						'"], .offcanvas-toggler.mobile-nav-btn[aria-controls="' +
						offCanvas.id +
						'"]'
				);
				if (openTrigger) {
					openTrigger.focus();
				}
			}
		});

		// Close submenu when focus out of last VISIBLE menu item
		let currFocus = document;
		document.addEventListener('keyup', (e) => {
			if ('Tab' === e.key && body.classList.contains('offcanvas-open')) {
				const canvasItems = offCanvas.querySelectorAll('a, button, [tabindex]');
				const visibleItems = [];
				canvasItems.forEach((item) => {
					if (item.checkVisibility()) {
						visibleItems.push(item);
					}
				});

				if (visibleItems.length && currFocus === visibleItems[visibleItems.length - 1]) {
					toggleOffCanvas(offCanvas, toggleButton);
					body.classList.remove('offcanvas-open');
					toggleOffCanvasTabbing();
				}
				currFocus = e.target;
			}
		});
	});

	toggleOffCanvasTabbing();
});

// FacetWP tabindex can only be changed with an action
document.addEventListener('facetwp-loaded', () => {
	if ('undefined' !== typeof FWP.hooks) {
		FWP.hooks.addAction(
			'facetwp/loaded',
			function () {
				toggleOffCanvasTabbing();
			},
			1000
		);
	}
});

function toggleOffCanvasTabbing() {
	const links = document.querySelectorAll(
		'.offcanvas button, .offcanvas a, .offcanvas .fa-chevron-down, .offcanvas [tabindex]'
	);
	links.forEach((link) => {
		if (!document.body.classList.contains('offcanvas-open')) {
			link.setAttribute('tabindex', '-1');
		} else {
			link.setAttribute('tabindex', '0');
		}
	});
}

function toggleMobileSubmenu(parent) {
	const subMenu = parent.querySelector('.sub-menu');
	subMenu.classList.toggle('hidden');
	parent.classList.toggle('open');
	parent.querySelector('.fa-chevron-down').classList.toggle('rotate-180');
}

function toggleOffCanvas(offCanvas, toggleButton) {
	const toggleClasses = ['translate-x-full', 'translate-x-0', 'pointer-events-none', 'pointer-events-auto'];
	toggleClasses.map((list) => offCanvas.classList.toggle(list));
	toggleButton.forEach((button) => {
		button.querySelectorAll('.open-button').forEach((el) => el.classList.toggle('!hidden'));
		button.querySelectorAll('.close-button').forEach((el) => el.classList.toggle('!hidden'));
	});
	offCanvas.toggleAttribute('data-open');
	document.body.classList.toggle('overflow-hidden');

	const isOpen = offCanvas.hasAttribute('data-open');
	offCanvas.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

	const controlledId = offCanvas.id;
	if (controlledId) {
		document.querySelectorAll('[aria-controls="' + controlledId + '"]').forEach((button) => {
			button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});
	}
}
